export const formatNumber = (inputNumber: number | undefined): string => {
    if (inputNumber == undefined) return '0';
    return new Intl.NumberFormat().format(inputNumber);
};
